export default __webpack_public_path__ + "static/media/bench-window-back-trapezoid-front.a62956f8.webp";